/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandTelegram = createReactComponent("brand-telegram", "IconBrandTelegram", [
  ["path", { d: "M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4", key: "svg-0" }]
]);

export { IconBrandTelegram as default };
//# sourceMappingURL=IconBrandTelegram.js.map
